export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref4601.63dadaa9.jpg";